import { QueryClient } from "react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

export * from "./useTimeZones";
export * from "./useTaxRates";
export * from "./useInvoiceItemTemplates";
export * from "./useInvoiceNoteTemplates";
export * from "./useInvoiceTemplate";
export * from "./useSecurity";
export * from "./useLabelsColors";
export * from "./useSystemStatus";
export * from "./useIntegrations";
export * from "./useOldVersions";
export * from "./useCompletedProjects";
export * from "./useEstimates";
export * from "./useTasksListViewSettings";
export * from "./useQueryData";
export * from "./useTaskPageNavigation";
export * from "./useDiscussionNavigation";
export * from "./useNotebooks";
export * from "./useHistoryOfChanges";
export * from "./useNoteVersions";
export * from "./useNoteNavigation";
export * from "./useAccessLogs";
export * from "./usePermamentlyDeleteMutation";
export * from "./useProjectCounters";
export * from "./useAvailableJobTypes";
export * from "./useAvailability";
export * from "./useTimeRecordsTotalInfo";
export * from "./usePeople";
export * from "./useReportsWidgetData";
export * from "./useMyWorkDisplaySettings";
export * from "./useProjectsFilter";
export * from "./useReportsAvailableCurrencies";
export * from "./useTrash";
export * from "./useArchive";
export * from "./useIntercomData";
export * from "./useRunReport";
export * from "./useReportViewOptions";
export * from "./useReportUninvoiced";
export * from "./useDataFilterPresets";
export * from "./useCompanies";
export * from "./useProjectProgress";
export * from "./useInvoices";
export * from "./useWorkloadTasks";
export * from "./useWorkloadSubtasks";
export * from "./useWorkloadGhostTasks";
export * from "./useWorkloadEvents";
export * from "./useCostSummary";
export * from "./useAnalyzeExpenseFile";
export * from "./useSuggestTasks";
export * from "./usePromptLogFeedback";
export * from "./useSuggestSubtasks";
export * from "./useBudgetThresholds";
export * from "./useNotifications";
export * from "./useTeams";
export * from "./useReminderParent";
export * from "./useAddressSuggestion";
export * from "./useBatchCreateVirtualUsers";
export * from "./useProjectTemplates";
export * from "./useCapacity";
export * from "./useApiTokens";
export * from "./useMcp";
